import HeaderVariantDefault from './HeaderVariantDefault.component';
export default HeaderVariantDefault;